import { windowModule } from "@/modules/window";

interface OpenMemAgentSlackConnectedDestinationInNewTabArgs {
  closeSlackConnectedModal: () => void;
  slackUrl?: string | null;
}

export const openMemAgentSlackConnectedDestinationInNewTab = async ({
  closeSlackConnectedModal,
  slackUrl,
}: OpenMemAgentSlackConnectedDestinationInNewTabArgs): Promise<void> => {
  closeSlackConnectedModal();

  if (!slackUrl) {
    return;
  }

  await windowModule.openInNewTab({
    url: new URL(slackUrl),
  });
};
